var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import updateFeed from '../../requests/feed/updateFeed';
/**
 *
 */
var UpdateFeedCommand = /** @class */ (function (_super) {
    __extends(UpdateFeedCommand, _super);
    function UpdateFeedCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param feed Feed
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    UpdateFeedCommand.prototype.execute = function (feed, organisationId, intl) {
        this.intl = intl;
        this.feed = feed;
        var promise = updateFeed(feed, organisationId);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    UpdateFeedCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.feed.edited' }, Object(this.feed)), 'dark', true);
    };
    return UpdateFeedCommand;
}(Command));
export default UpdateFeedCommand;
